import { endpointStatistic } from './base.config';

export const statistic = {
  // payment
  getTotalPaymentByStatusForeachCompany: endpointStatistic + `/bilagsky-statistic/payment/get-payment-statistic`,
  getCompaniesStatistic: endpointStatistic + `/bilagsky-statistic/payment/get-list-company-statistic`,
  getSumPaymentByStatus: endpointStatistic + `/bilagsky-statistic/payment/sum-amount-payment`,
  getYearByPayment: endpointStatistic + `/bilagsky-statistic/payment/get-years-by-payment`,
  getResponsibleAccountantPayment: endpointStatistic + `/bilagsky-statistic/payment/get-responsible-payment`,
  getCounterPaymentFailed: endpointStatistic + `/bilagsky-statistic/payment/get-counter-payment-failed-all-year`,
  getCountPaymentByFilter: endpointStatistic + `/bilagsky-statistic/payment/get-count-payment-by-filter`,
  checkIsAccountantPaymentStatistic:
    endpointStatistic + `/bilagsky-statistic/payment/check-is-accountant-payment-statistic`,
  getAssignedFromPaymentStatistic:
    endpointStatistic + `/bilagsky-statistic/payment/get-assigned-from-payment-statistic`,
  getUserAssignedPaymentStatistic:
    endpointStatistic + `/bilagsky-statistic/payment/get-user-assigned-by-accountant-statistic`,
  getDataChartPaymentStatistic: endpointStatistic + `/bilagsky-statistic/payment/chart-payment-statistic`,
  // payment by supplier
  getResponsibleBySupplierHard: endpointStatistic + `/bilagsky-statistic/payment/get-responsible-by-supplier`,
  getPaymentListBySupplierHard: endpointStatistic + `/bilagsky-statistic/payment/get-payment-by-supplier-permanent`,
  getTotalAndSumBySuppplierHard: endpointStatistic + `/bilagsky-statistic/payment/get-total-and-sum-by-supplier`,
  checkIsAccountantPaymentSupplier:
    endpointStatistic + `/bilagsky-statistic/payment/check-is-accountant-payment-supplier`,
  getAssignedFromPaymentSupplier: endpointStatistic + `/bilagsky-statistic/payment/get-assigned-from-payment-supplier`,
  getUserAssignedPaymentSupplier:
    endpointStatistic + `/bilagsky-statistic/payment/get-user-assigned-by-accountant-supplier`,
  getDataChartPaymentSupplier: endpointStatistic + `/bilagsky-statistic/payment/chart-payment-supplier`,
  getYearPaymentSupplier: endpointStatistic + `/bilagsky-statistic/payment/get-year-supplier`,
  // voucher
  getTotalVoucherMissing: endpointStatistic + `/bilagsky-statistic/voucher/get-voucher-unpaid-statistic`,
  getYearVoucherMissing: endpointStatistic + `/bilagsky-statistic/voucher/get-years`,
  getCompaniesVoucherMissing: endpointStatistic + `/bilagsky-statistic/voucher/get-companies`,
  voucherMissingGetResponsibleAccountant: endpointStatistic + `/bilagsky-statistic/voucher/responsile-accountants`,
  voucherMissingGetResponsibleAssigned: endpointStatistic + `/bilagsky-statistic/voucher/accoutants-assigned`,
  voucherMissingCheckIsAccountant: endpointStatistic + `/bilagsky-statistic/voucher/check-is-accountant`,
  getAssignedFromVoucher: endpointStatistic + `/bilagsky-statistic/voucher/get-assigned-from`,
  getUserAssignedByAccountantVoucher: endpointStatistic + `/bilagsky-statistic/voucher/get-user-assigned-by-accountant`,
  getDataChartVoucher: endpointStatistic + `/bilagsky-statistic/voucher/chart/overview`,
  getDataChartVoucherByCompanies: endpointStatistic + `/bilagsky-statistic/voucher/chart/companies`,
  // bank
  getBankMissing: endpointStatistic + `/bilagsky-statistic/bank/get-transaction-missing`,
  getYearBankMissing: endpointStatistic + `/bilagsky-statistic/bank/years`,
  getCompaniesBankMissing: endpointStatistic + `/bilagsky-statistic/bank/companies`,
  getResponsibleAccountantsBankMissing: endpointStatistic + `/bilagsky-statistic/bank/responsile-accountants`,
  getAccountantAssignedBankMissing: endpointStatistic + `/bilagsky-statistic/bank/accoutants-assigned`,
  bankMissingCheckIsAccountant: endpointStatistic + `/bilagsky-statistic/bank/check-is-accountant`,
  getAssignedFromBank: endpointStatistic + `/bilagsky-statistic/bank/get-assigned-from`,
  getUserAssignedByAccountantBank: endpointStatistic + `/bilagsky-statistic/bank/get-user-assigned-by-accountant`,
  getBankIntegration: endpointStatistic + `/bilagsky-statistic/bank/get-bank-integration`,
  getCompaniesBankIntegration: endpointStatistic + `/bilagsky-statistic/bank/get-company-bank-integration`,
  // Altinn
  getYearsMVA: endpointStatistic + `/bilagsky-statistic/altinn/get-years`,
  getResponsibleAccountantsMVA: endpointStatistic + `/bilagsky-statistic/altinn/get-responsible-accountants`,
  getListMVA: endpointStatistic + `/bilagsky-statistic/altinn`,
  getCompaniesMVA: endpointStatistic + `/bilagsky-statistic/altinn/get-companies`,
  getDataChartBank: endpointStatistic + `/bilagsky-statistic/bank/chart/overview`,
  getDataChartBankByCompanies: endpointStatistic + `/bilagsky-statistic/bank/chart/companies`,
  // Voucher
  getVouchrSent: endpointStatistic + `/bilagsky-statistic/voucher/get-voucher-sent-statistic`,

  // Missing auto
  getMissingAuto: endpointStatistic + '/statistics/missing-auto',
  refreshMissingAutoData: endpointStatistic + '/statistics/missing-auto/:companyId/refresh',
  // Company Package History
  getCompanyPaymentPackagesHistory: `${endpointStatistic}/statistics/payment-packages-history`,
  getPaymentPackagesHistoryByCompanyId: `${endpointStatistic}/statistics/payment-packages-history/:companyId`,
  // Fiken
  getFikenIntegrations: `${endpointStatistic}/statistics/fiken/integrations`,
  getFikenPushLogs: `${endpointStatistic}/statistics/fiken/push-logs`,
  getFikenPushLogTransactions: `${endpointStatistic}/statistics/fiken/push-logs/transactions`,
  getFikenTransactions: `${endpointStatistic}/statistics/fiken/transactions`,
  getFikenTransactionById: `${endpointStatistic}/statistics/fiken/transactions/:transactionId`,
  getFikenTransactionStats: `${endpointStatistic}/statistics/fiken/transactions/stats`,
  updateFikenTransactionStatusById: `${endpointStatistic}/statistics/fiken/transactions/:transactionId/status`,
  getFikenInboxStatistics: `${endpointStatistic}/statistics/fiken/inbox`,
  syncFikenInboxStatistics: `${endpointStatistic}/statistics/fiken/inbox/:companyId/sync`,
  // Invitation
  getInvitationList: `${endpointStatistic}/statistics/invitation`,
  getAccountingCompanyList: `${endpointStatistic}/statistics/invitation/accounting-companies`,
};

export const statisticV2 = {
  fetchAllStatisticPayments: `${endpointStatistic}/v2/statistics/payments`,
  getPaymentCurrencies: `${endpointStatistic}/v2/statistics/payments/currencies`,
  getResponsibleAccountants: `${endpointStatistic}/v2/statistics/company-info/responsible-accountants`,
  getAssignedUsers: `${endpointStatistic}/v2/statistics/company-assigned/assigned-users`,
  getTotalPaymentFailed: `${endpointStatistic}/v2/statistics/payments/failed`,
  fetchAllStatisticEcofinans: `${endpointStatistic}/v2/statistics/payments/eco-finans`,
  getVoucherSent: `${endpointStatistic}/v2/statistics/voucher/sent`,
  getVoucherUnpaid: `${endpointStatistic}/v2/statistics/voucher/unpaid`,
  getBankIntegration: `${endpointStatistic}/v2/statistics/bank/integration`,
  getBankMissing: `${endpointStatistic}/v2/statistics/bank/missing`,
  getAltinnMVA: `${endpointStatistic}/v2/statistics/altinn`,
  getAllCompanies: `${endpointStatistic}/v2/statistics/company/all`,
  exportPDFBankPrivateOrLost: `${endpointStatistic}/v2/statistics/bank/private-lost/export-pdf`,
  exportPDFBankStatement: `${endpointStatistic}/v2/statistics/bank/statement/export-pdf`,
  exportXlsxBankStatement: `${endpointStatistic}/v2/statistics/bank/statement/export-xlsx`,
  exportCSVBankStatement: `${endpointStatistic}/v2/statistics/bank/statement/export-csv`,
  getBankStatement: `${endpointStatistic}/v2/statistics/bank/statement`,
  getValidIBUBMonthsByAccount: `${endpointStatistic}/v2/statistics/bank/statement/valid-months`,
  getVoucherSources: `${endpointStatistic}/v2/statistics/voucher/sources`,
  countVoucherSources: `${endpointStatistic}/v2/statistics/voucher/sources/count`,
};
